import gql from 'graphql-tag';

const FORCE_QUEUED_PRICE_CHANGE = gql`
	mutation forcePriceChange ($id: ID!) {
		forcePriceChange(id: $id) {
			id
			price
			queuedPrice
			queuedPriceType
		}
	}
`;

export default FORCE_QUEUED_PRICE_CHANGE;

